/* Berry Blush Theme JS */

(function () {
  'use strict';

  /* ---- Sticky Header ---- */
  const siteHeader = document.getElementById('site-header');
  if (siteHeader) {
    const handleScroll = () => {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  /* ---- Search Drawer Toggle ---- */
  const searchToggle = document.getElementById('search-toggle');
  const searchDrawer = document.getElementById('search-drawer');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function () {
      const isOpen = searchDrawer.classList.toggle('is-open');
      searchDrawer.setAttribute('aria-hidden', !isOpen);
      if (isOpen) {
        const input = searchDrawer.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---- Mobile Menu Drawer ---- */
  const mobileMenuOpen = document.getElementById('mobile-menu-open');
  const mobileMenuClose = document.getElementById('mobile-menu-close');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-menu-overlay');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    mobileMenu.setAttribute('aria-hidden', 'false');
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    mobileMenu.setAttribute('aria-hidden', 'true');
  }

  if (mobileMenuOpen) mobileMenuOpen.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  document.querySelectorAll('.mobile-menu__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.mobile-menu__item');
      if (item) item.classList.toggle('is-open');
    });
  });

  /* ---- Cart Drawer ---- */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerClose = document.getElementById('cart-drawer-close');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart();
      openCartDrawer();
    });
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeCartDrawer();
      if (searchDrawer) searchDrawer.classList.remove('is-open');
    }
  });

  /* ---- Cart API ---- */
  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function (err) { console.error('Cart fetch error:', err); });
  }

  function renderCart(cart) {
    const itemsEl = document.getElementById('cart-drawer-items');
    const footerEl = document.getElementById('cart-drawer-footer');
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      if (footerEl) footerEl.innerHTML = '';
      updateCartCount(0);
      return;
    }

    const itemsHtml = cart.items.map(function (item) {
      return '<div class="cart-drawer__item" data-key="' + item.key + '">' +
        '<img class="cart-drawer__item-img" src="' + (item.image || '') + '" alt="' + escapeHtml(item.title) + '" width="65" height="65" loading="lazy">' +
        '<div>' +
          '<div class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</div>' +
          '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cart-drawer__item-actions">' +
            '<button class="cart-drawer__qty-btn" data-qty-change="-1" data-key="' + item.key + '" aria-label="Decrease quantity">&#8722;</button>' +
            '<span class="cart-drawer__qty">' + item.quantity + '</span>' +
            '<button class="cart-drawer__qty-btn" data-qty-change="1" data-key="' + item.key + '" aria-label="Increase quantity">&#43;</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    itemsEl.innerHTML = itemsHtml;
    updateCartCount(cart.item_count);

    if (footerEl) {
      footerEl.innerHTML =
        '<div class="cart-drawer__subtotal">' +
          '<span>Subtotal</span>' +
          '<span>' + formatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<a href="/checkout" class="cart-drawer__checkout-btn">Proceed to Checkout</a>' +
        '<a href="/cart" class="cart-drawer__view-btn">View full bag</a>';
    }

    itemsEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.key;
        const change = parseInt(btn.dataset.qtyChange, 10);
        const qtyEl = btn.parentElement.querySelector('.cart-drawer__qty');
        const currentQty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        const newQty = Math.max(0, currentQty + change);
        updateCartItem(key, newQty);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function (err) { console.error('Cart update error:', err); });
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
    });
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return window.Shopify && window.Shopify.currency
      ? '₹' + amount
      : '₹' + amount;
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ---- Add to Cart Handler ---- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) {
      // Demo fallback if no variant
      openCartDrawer();
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        fetchCart();
        openCartDrawer();
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      });
  });

  /* ---- Bestsellers Horizontal Scroll Arrows ---- */
  document.querySelectorAll('.bestsellers-track-wrap').forEach(function (wrap) {
    const track = wrap.querySelector('.bestsellers-track');
    const prevBtn = wrap.querySelector('.arrow--prev');
    const nextBtn = wrap.querySelector('.arrow--next');
    if (!track) return;

    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -220, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: 220, behavior: 'smooth' }); });
  });

  /* ---- Fetch Initial Cart Count ---- */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); })
    .catch(function () {});

})();
